module.exports = __webpack_public_path__ + "img/cmb.e7c5d145.jpg";